<template>
  <h1>Einstellungen</h1>

  <hr class="my-4" />

  <DatabaseInfoSection />

  <UsersSection />

  <ApiKeysSection />
</template>

<script lang="ts" setup>
  import DatabaseInfoSection from '@/components/Einstellungen/DatabaseInfo/DatabaseInfoSection.vue';
  import UsersSection from '@/components/Einstellungen/Users/UsersSection.vue';
  import ApiKeysSection from '@/components/Einstellungen/ApiKeys/ApiKeysSection.vue';
</script>
